import PriorityOverviewShow from "./show";


if (document.body.getAttribute("data-current-path") === "settings/priorities") {
    const action = document.body.getAttribute("data-current-action")
    if(action === "show") {
        new PriorityOverviewShow();
    }
}